import React from "react";
import { Col, Container, Row } from "reactstrap";
import { TabletRoleManagement } from "./TabletRoleManagement";

export function GdRoleManagement() {
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
            <h3 style={{ marginBottom: 30, color:"#024b82" }}>Gestión de roles</h3>
        </Col>
      </Row>
      <Row>
        <TabletRoleManagement/>
      </Row>
     
    </Container>
  );
}

